import React, { useRef } from 'react';
import { Button, Space, message } from 'antd';
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';

interface FileUploadSectionProps {
  onParticipationUpload: (file: File) => Promise<void>;
  onACHVoucherUpload: (file: File) => Promise<void>;
}

export const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  onParticipationUpload,
  onACHVoucherUpload,
}) => {
  const participationFileInputRef = useRef<HTMLInputElement>(null);
  const achVoucherFileInputRef = useRef<HTMLInputElement>(null);

  const handleParticipationUpload = () => {
    participationFileInputRef.current?.click();
  };

  const handleACHVoucherUpload = () => {
    achVoucherFileInputRef.current?.click();
  };

  const validateFileName = (filename: string): boolean => {
    if (filename.toLowerCase().includes('reconciliation')) {
      message.error('Invalid file type');
      return false;
    }
    return true;
  };

  const handleParticipationFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (validateFileName(file.name)) {
        onParticipationUpload(file);
      }
    }
    event.target.value = '';
  };

  const handleACHVoucherFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (validateFileName(file.name)) {
        onACHVoucherUpload(file);
      }
    }
    event.target.value = '';
  };



  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Space size="middle">
          <Button 
            type="primary" 
            icon={<UploadOutlined />} 
            onClick={handleParticipationUpload}
            size="large"
          >
            Upload Participation Report
          </Button>
          <Button 
            type="primary"
            icon={<UploadOutlined />} 
            onClick={handleACHVoucherUpload}
            size="large"
          >
            Upload ACH Voucher
          </Button>
        </Space>
        <a 
          href="https://cdn.percapita.com/channelpartners/Percapita%20Resources.pptx" 
          download
          style={{ textDecoration: 'none' }}
        >
          <Button 
            type="default"
            icon={<DownloadOutlined />} 
            size="large"
          >
            Percapita Resources.pptx
          </Button>
        </a>
      </div>

      <input
        ref={participationFileInputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={handleParticipationFileChange}
      />
      <input
        ref={achVoucherFileInputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={handleACHVoucherFileChange}
      />
    </>
  );
}; 